a<template>
    <footer>
        <div class = "footerText">
            <span>Georeferenced ports data presented in this page are licensed under <b>CC-BY-SA 4.0</b> <a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en">https://creativecommons.org/licenses/by-sa/4.0/deed.en</a>.</span>
            Authors of this database have worked on <a href="https://navigocorpus.hypotheses.org">Navigo corpus project</a>, and now on the <a href="http://www.agence-nationale-recherche.fr/Project-ANR-18-CE38-0010">PortIC project</a>.
            Credits are attributed to <a href="http://iao.cnrs.fr/Jean-Pierre-DEDIEU">Jean-Pierre Dedieu, IAO lab.</a>, <a href="https://cmmc-nice.fr/membres-du-cmmc/silvia-marzagalli/">Silvia Marzagalli, CMMC lab.</a>, <a href="http://criham.labo.univ-poitiers.fr/les-chercheurs/les-membres-titulaires-du-criham/thierry-sauzeau/">Thierry Sauzeau, CRIHAM lab.</a>, <a href="https://lienss.univ-larochelle.fr/Plumejeaud-Christine-IR">Christine Plumejeaud-Perreau, LIENSs lab.</a>.
        </div>
        <div id="img-lienss" >
            <a onclick="window.open(this.href); return false;" href="http://lienss.univ-larochelle.fr/">
                <img  alt="lienss" src="../../img/lienss.png">
            </a>

        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer",
        data : () =>({
            document: '',
            fenetre : ''
        }),
        created (){

        }
    }
</script>


<style scoped>

    footer
    {

        background-color: #28527a;
        display : flex;
        height: 100px;
        bottom: 0;
        width: 100%;
        position : absolute;

    }

    .footerText
    {
        margin-left: 100px;
        text-justify: auto;
        height: 90px;
        color:white;
        margin-right: 300px;
        text-align:justify;
    }


    #img-lienss
    {
        height: 90px;
        width : 320px;
        background-color: rgba(256, 256, 256, 1);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        -moz-box-shadow: 5px 5px 10px 0px #333333;
        -webkit-box-shadow: 5px 5px 10px 0px #333333;
        -o-box-shadow: 5px 5px 10px 0px #333333;
        box-shadow: 5px 5px 10px 0px #333333;
        filter:progid:DXImageTransform.Microsoft.Shadow(color=#333333, Direction=134, Strength=10);
        margin-top: 5px;
        padding: 5px;
        cursor: pointer;
        margin-right: 10px;

    }

</style>


// WEBPACK FOOTER //
// src-detail/components/VUE/Footer.vue